import React from 'react'

export interface IconCommentProps {
    className?: string
    fill?: string
}

export const IconComment: React.FC<IconCommentProps> = ({
    className,
    fill = '#2B2D2E',
}) => (
    <svg viewBox="0 0 24 24" fill="none" className={className}>
        <title>Comments</title>
        <path
            d="M8 10H8.01M12 10C12.0039 10 12.01 10 12.01 10M16 10C16 10 16.0061 10 16.01 10M9 16H5C3.89543 16 3 15.1046 3 14V6C3 4.89543 3.89543 4 5 4H19C20.1046 4 21 4.89543 21 6V14C21 15.1046 20.1046 16 19 16H14L9 21V16Z"
            stroke={fill}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
IconComment.displayName = 'IconComment'
